// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"53968d3e","455":"e3f67d83","661":"f62cf86a","977":"d889b74c"}[chunkId] + ".chunk.js";
};